// Shared responsive breakpoints. Below MOBILE_BREAKPOINT the sidebar
// overlays content instead of pushing it, and tables scroll horizontally.
// Between MOBILE_BREAKPOINT and TABLET_BREAKPOINT is the "tablet" band.
export const MOBILE_BREAKPOINT = 768;
export const TABLET_BREAKPOINT = 1024;

export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;
export const TABLET_MEDIA_QUERY = `(min-width: ${MOBILE_BREAKPOINT}px) and (max-width: ${
  TABLET_BREAKPOINT - 1
}px)`;
export const DESKTOP_MEDIA_QUERY = `(min-width: ${MOBILE_BREAKPOINT}px)`;

/**
 * Scales a container's base padding down for smaller screens: 2/3 of the
 * base value on tablet, 1/2 on mobile. Spread the result into a style
 * object alongside the base `padding`.
 */
export function responsiveContainerPadding(
  basePaddingPx: number,
): Record<string, Record<string, string>> {
  return {
    [`@media ${TABLET_MEDIA_QUERY}`]: {
      padding: `${Math.round((basePaddingPx * 2) / 3)}px`,
    },
    [`@media ${MOBILE_MEDIA_QUERY}`]: {
      padding: `${Math.round(basePaddingPx / 2)}px`,
    },
  };
}
